export default __webpack_public_path__ + "static/Geologica-SemiBold-6fc71a9f5f227b615a395b69a671031e.woff2";